import React from 'react';
import { siteConfig } from '../../data/siteConfig';
interface BrandLogoProps {
  className?: string;
  /** The footer keeps the complete supplied logo, including its web address. */
  showUrl?: boolean;
}

/**
 * Supplied FINAL Logo.jpg. Its flat source background is RGB236/235/230.
 * Brightness and multiply blend it into the page surface without redrawing the art.
 * The header's SVG viewport trims source padding and the URL; its display widths
 * are proportional to the 410px crop, preserving the previous 176/462 and 224/462
 * artwork scales. The footer keeps its existing complete-logo treatment.
 */
export function BrandLogo({
  className = '',
  showUrl = false
}: BrandLogoProps) {
  if (!showUrl) {
    return <svg role="img" aria-label={siteConfig.brandName} viewBox="30 22 410 154" width="410" height="154" className={`block h-auto brightness-[1.14] mix-blend-multiply ${className}`} data-id="element-453" data-mp="vicacmbsscu2">
        <image href={siteConfig.logoUrl} x="0" y="0" width="462" height="264" data-id="element-454" data-mp="3g7jit9w4k414" />
      </svg>;
  }
  return <span className={`relative block overflow-hidden ${className}`} style={{
    aspectRatio: '462 / 264'
  }} data-id="element-455" data-mp="18bgtgqhictna">
      <img src={siteConfig.logoUrl} alt={siteConfig.brandName} className="absolute inset-x-0 top-0 w-full brightness-[1.14] mix-blend-multiply" data-id="element-456" data-mp="1mb8cx6qsn28o" />
    </span>;
}